import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { expandListBlocksToCompleteItems as _expandListBlocksToCompleteItems, expandListBlocksToCompleteList as _expandListBlocksToCompleteList, isFirstBlockOfListItem as _isFirstBlockOfListItem, isListItemBlock as _isListItemBlock } from './utils/model.js';
/**
 * A set of helpers related to document lists.
 */
var ListUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(ListUtils, _Plugin);
  var _super = _createSuper(ListUtils);
  function ListUtils() {
    _classCallCheck(this, ListUtils);
    return _super.apply(this, arguments);
  }
  _createClass(ListUtils, [{
    key: "expandListBlocksToCompleteList",
    value:
    /**
     * Expands the given list of selected blocks to include all the items of the lists they're in.
     *
     * @param blocks The list of selected blocks.
     */
    function expandListBlocksToCompleteList(blocks) {
      return _expandListBlocksToCompleteList(blocks);
    }
    /**
     * Check if the given block is the first in the list item.
     *
     * @param listBlock The list block element.
     */
  }, {
    key: "isFirstBlockOfListItem",
    value: function isFirstBlockOfListItem(listBlock) {
      return _isFirstBlockOfListItem(listBlock);
    }
    /**
     * Returns true if the given model node is a list item block.
     *
     * @param node A model node.
     */
  }, {
    key: "isListItemBlock",
    value: function isListItemBlock(node) {
      return _isListItemBlock(node);
    }
    /**
     * Expands the given list of selected blocks to include the leading and tailing blocks of partially selected list items.
     *
     * @param blocks The list of selected blocks.
     * @param options.withNested Whether should include nested list items.
     */
  }, {
    key: "expandListBlocksToCompleteItems",
    value: function expandListBlocksToCompleteItems(blocks) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _expandListBlocksToCompleteItems(blocks, options);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ListUtils';
    }
  }]);
  return ListUtils;
}(Plugin);
export { ListUtils as default };